import React from "react";
import {
  defineBlock,
  useEditor,
  ChildrenBlock,
} from "@smartfire/gutenberg-react";
import style from "./block.module.scss";
import { InnerBlocks } from "@wordpress/block-editor";

function Block() {
  const { isEditing } = useEditor();

  return (
    <div className={style.block + " " + (isEditing && style.blockAdmin)}>
      <div className={!isEditing && "content-container"}>
        <div className={style.columns}>
          {isEditing ? (
            <InnerBlocks
              template={[
                ["smartfire/froid-product-specs-list-container", {}],
                ["smartfire/froid-product-specs-array-container", {}],
              ]}
              templateLock="all"
            />
          ) : (
            <ChildrenBlock />
          )}
        </div>
      </div>
    </div>
  );
}

export default defineBlock({
  Block,
  setup: {
    title: "Froid - Espace specs produit",
  },
});
